/* Built In Imports */
import React, { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import EventsCommonUI from '@components/UI/Events/EventsCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';
// import TopBannerEvent from '@components/HeaderBanner/TopBannerEvent';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData, filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import { fetchDetails } from 'services/eventsService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Events Landing Page Data
 */
const Ishanga7 = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  // consoleLog('page', pageData);
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      />
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" maxW="1300px" mx="auto">
        <EventsCommonUI
          pageBody={pageData?.body}
          region={region}
          lang={language}
          pageName="ishanga7"
        />
      </Box>
      <style>
        {`
          h2{
            color: #02026C;
            margin-top:20px;
          }
        `}
      </style>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let ishanga7LandingPath =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.ishanga7
      ? [
          `/in/en/events/special-events/ishanga7`,
          `/ca/en/events/special-events/ishanga7`,
          `/us/en/events/special-events/ishanga7`,
          `/in/ta/events/special-events/ishanga7`,
        ]
      : [];
  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    ishanga7LandingPath = filterBuildUrls(
      'landing_pages',
      'L2',
      '/events/special-events/ishanga7',
      '/events/special-events/ishanga7-',
      data
    );
  }
  return {
    paths: ishanga7LandingPath,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    region,
    language,
    `special-events/ishanga7`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false
    }
  };
};

export default Ishanga7;
